import { ConfigurationDto } from '~shared/api/api.types';
import { Configuration } from '../model/configuration.types';
import { oneIdentifier } from '~shared/config/hostname';

/*
CHANGED: 

roomCategories -> rooms
packageGroups -> packages
mediums -> images
features deleted from the main response, pushed into rooms
*/

export const transformConfigurationDtoToConfiguration = (
  configurationDto: ConfigurationDto,
): Configuration => {
  const allRooms = configurationDto.roomCategories.map(room => ({
    id: room.id,
    sort: room.sort,
    name: room.name,
    subtitle: room.subtitle,
    teaser: room.teaser,
    description: room.description,
    size: room.size,
    images: room.mediums,
    minimumOccupancy: room.minimumOccupancy,
    maximumOccupancy: room.maximumOccupancy,
    features: room.features
      .map(featureId =>
        configurationDto.roomCategoryFeatures.find(
          ({ id }) => featureId === id,
        ),
      )
      .filter(i => !!i),
    descriptions: room.descriptions,
  }));

  // Filter out room category 1692227 (Einzelzimmer) when access key is 804ff83e (Schlosshotel Fiss)
  const rooms =
    oneIdentifier === 'schlosshotel'
      ? allRooms.filter(room => room.id !== 1692227)
      : allRooms;

  const packageCategories = configurationDto.packageCategories.map(
    packageCategory => ({
      id: packageCategory.id,
      sort: packageCategory.sort,
      name: packageCategory.name,
      teaser: packageCategory.teaser,
      description: packageCategory.description,
      packages: packageCategory.packageGroups.map(packageItem => ({
        id: packageItem.id,
        sort: packageItem.sort,
        name: packageItem.name,
        teaser: packageItem.teaser,
        description: packageItem.description,
        includedServices: packageItem.includedServices,
        stayRanges: packageItem.stayRanges,
        images: packageItem.mediums,
      })),
      images: packageCategory.mediums,
    }),
  );

  const lastMinutePackages = configurationDto.lastMinutePackages.map(
    lastMinutePackage => ({
      id: lastMinutePackage.id,
      name: lastMinutePackage.name,
      teaser: lastMinutePackage.teaser,
      description: lastMinutePackage.description,
      duration: lastMinutePackage.duration,
      arrivalDay: lastMinutePackage.arrivalDay,
      images: lastMinutePackage.mediums,
      room: rooms.find(({ id }) => id === lastMinutePackage.roomCategoryId),
    }),
  );

  return {
    rooms,
    packageCategories,
    lastMinutePackages,

    adultAge: configurationDto.adultAge,
    defaultAdults: configurationDto.defaultAdults,
    minChildren: configurationDto.minChildren,
    maxChildren: configurationDto.maxChildren,
    rates: configurationDto.rates,
    extraServices: configurationDto.extraServices,
    salesInfos: configurationDto.salesInfos,
    pageCustomization: configurationDto.pageCustomization,
    languages: configurationDto.languages,
    bookingEnabled: configurationDto.bookingEnabled,
    inquiryEnabled: configurationDto.inquiryEnabled,
    countries: configurationDto.countries,
  };
};
